module.exports = __webpack_public_path__ + "howl.da513c9c4248ed9a01b8d7238b662ec2.webp";